(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qsf-sextou"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('qsf-sextou-campaign')) return;
  class SextouCampaign extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.root = (this.dataset.root || '/').replace(/\/?$/, '/');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.status = this.querySelector('[data-sx-status]');
      this.cartLink = this.querySelector('[data-sx-cart-link]');
      this.stage = this.querySelector('.sx-scene');
      this.price = this.querySelector('[data-sx-price]');
      this.pricePack = this.querySelector('[data-sx-price-pack]');
      this.frame = 0;
      this.busy = false;
      this.messages = this.dataset.language === 'es' ? {
        adding:'Añadiendo al carrito…', added:'Añadido al carrito.',
        confirm:'No hemos podido confirmar la respuesta. Comprueba el carrito antes de volver a intentarlo.',
        drawer:'Producto añadido. No se ha podido abrir el carrito lateral; ábrelo con el icono del menú.',
        invalid:'Selecciona un formato válido.', error:'No se ha podido añadir este formato.'
      } : {
        adding:'A adicionar ao carrinho…', added:'Adicionado ao carrinho.',
        confirm:'Não conseguimos confirmar a resposta. Verifica o carrinho antes de tentares novamente.',
        drawer:'Produto adicionado. Não foi possível abrir o carrinho lateral; abre-o pelo ícone do menu.',
        invalid:'Seleciona um formato válido.', error:'Não foi possível adicionar este formato.'
      };
      this.addEventListener('submit', event => this.addPack(event), {capture:true,signal});
      this.schedule = () => {if (!this.frame) this.frame = requestAnimationFrame(() => this.paint());};
      window.addEventListener('scroll', this.schedule, {passive:true,signal});
      window.addEventListener('resize', () => {this.headerSpacing();this.updateDiagonal();this.schedule();}, {passive:true,signal});
      window.addEventListener('load', () => {this.headerSpacing();this.updateDiagonal();this.schedule();}, {signal});
      this.reduced.addEventListener('change', this.schedule, {signal});
      document.addEventListener('visibilitychange', this.schedule, {signal});
      if (typeof ResizeObserver !== 'undefined') {
        this.headerObserver = new ResizeObserver(() => {this.headerSpacing();this.updateDiagonal();});
        document.querySelectorAll('.m-header__desktop,.m-header__mobile').forEach(node => this.headerObserver.observe(node));
        const divider=this.querySelector('.sx-divider');if(divider)this.headerObserver.observe(divider);
      }
      if (typeof IntersectionObserver !== 'undefined') {
        this.visibility = new IntersectionObserver(entries => {this.dataset.paused = !entries[0].isIntersecting;});
        this.visibility.observe(this);
      }
      const selected=this.querySelector('.sx-pack[aria-pressed="true"]') || this.querySelector('.sx-pack:not(:disabled)');
      if(selected) this.selectPack(selected);
      this.headerSpacing();this.updateDiagonal();this.schedule();
    }
    disconnectedCallback() {
      this.controller?.abort();this.headerObserver?.disconnect();this.visibility?.disconnect();
      cancelAnimationFrame(this.frame);this.frame=0;this.connected=false;
    }
    updateDiagonal() {
      const divider=this.querySelector('.sx-divider');if(!divider)return;
      const box=divider.getBoundingClientRect();if(!box.width || !box.height)return;
      divider.style.setProperty('--sx-slope-length',Math.hypot(box.width,box.height)+'px');
      divider.style.setProperty('--sx-slope-angle',(-Math.atan2(box.height,box.width)*180/Math.PI)+'deg');
    }
    headerSpacing() {
      const top=this.getBoundingClientRect().top+scrollY;
      let overlap=0;
      document.querySelectorAll('.m-header__desktop,.m-header__mobile').forEach(bar => {
        const box=bar.getBoundingClientRect();
        if(!box.width || !box.height || getComputedStyle(bar).visibility==='hidden') return;
        let parent=bar,fixed=false;
        while(parent && parent!==document.body){if(getComputedStyle(parent).position==='fixed'){fixed=true;break;}parent=parent.parentElement;}
        const bottom=fixed?Math.max(box.bottom,box.height):box.bottom+scrollY;
        overlap=Math.max(overlap,bottom-top);
      });
      this.style.setProperty('--sx-header-overlap',Math.max(0,Math.ceil(overlap))+'px');
    }
    paint() {
      this.frame=0;
      const box=this.stage.getBoundingClientRect();
      const progress=Math.max(-1,Math.min(1,(innerHeight/2-box.top-box.height/2)/((innerHeight+box.height)/2)));
      const distance=this.reduced.matches || document.hidden?0:Number(this.dataset.distance)||0;
      this.style.setProperty('--sx-scroll',Math.round(Math.min(0,(progress-1)*distance*.5))+'px');
    }
    notify(message,showLink=false) {
      if(!this.isConnected) return;
      this.status.textContent=message;this.cartLink.hidden=!showLink;
    }
    selectPack(button) {
      this.querySelectorAll('.sx-pack').forEach(node=>node.setAttribute('aria-pressed',String(node===button)));
      if(this.price && typeof button.dataset.price==='string') this.price.textContent=button.dataset.price;
      if(this.pricePack) this.pricePack.textContent=button.dataset.pack || '';
    }
    async refreshCount() {
      try {
        const response=await fetch(this.root+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
        if(!response.ok) return;
        const cart=await response.json();
        document.querySelectorAll('.m-cart-count').forEach(node=>{node.textContent=cart.item_count;node.classList.toggle('m:hidden',cart.item_count===0);});
      } catch (_) {}
    }
    async openDrawer(result,button) {
      let drawer=document.querySelector('m-cart-drawer');
      if(!drawer) throw new Error('Missing drawer');
      if(typeof drawer.renderContents!=='function') {
        let timer;
        try{await Promise.race([customElements.whenDefined('m-cart-drawer'),new Promise((_,reject)=>{timer=setTimeout(()=>reject(new Error('Drawer timeout')),4000);})]);}
        finally{clearTimeout(timer);}
        drawer=document.querySelector('m-cart-drawer');
      }
      if(!drawer || typeof drawer.renderContents!=='function' || typeof drawer.getSectionsToRender!=='function') throw new Error('Incompatible drawer');
      const descriptors=drawer.getSectionsToRender();
      if(!descriptors.length) throw new Error('Missing sections');
      const valid=sections=>descriptors.every(section=>{
        const html=sections?.[section.id];
        return typeof html==='string' && document.querySelector(section.selector) && new DOMParser().parseFromString(html,'text/html').querySelector(section.selector);
      });
      let sections=result.sections;
      if(!valid(sections)) {
        const url=new URL(this.root,location.origin);
        url.searchParams.set('sections',[...new Set(descriptors.map(section=>section.id))].join(','));
        const response=await fetch(url.toString(),{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
        if(!response.ok) throw new Error('Drawer refresh failed');
        sections=await response.json();
      }
      if(!valid(sections)) throw new Error('Incomplete sections');
      if(typeof drawer.setActiveElement==='function') drawer.setActiveElement(button);
      drawer.renderContents({...result,id:result.id || result.items?.[0]?.id,sections});
      this.notify('');
    }
    async addPack(event) {
      const form=event.target.closest('[data-sx-form]');
      if(!form || !this.contains(form)) return;
      event.preventDefault();event.stopImmediatePropagation();
      const button=event.submitter;
      if(this.busy || !button || button.disabled) return;
      const id=Number(button.value);
      if(!Number.isSafeInteger(id) || id<=0){this.notify(this.messages.invalid);return;}
      this.selectPack(button);
      this.busy=true;
      const buttons=[...form.querySelectorAll('button')],states=buttons.map(node=>node.disabled);
      buttons.forEach(node=>node.disabled=true);form.setAttribute('aria-busy','true');this.notify(this.messages.adding);
      let confirmed=false;
      try {
        const drawer=document.querySelector('m-cart-drawer');
        const sections=typeof drawer?.getSectionsToRender==='function'?[...new Set(drawer.getSectionsToRender().map(section=>section.id))].slice(0,5):['cart-drawer'];
        const response=await fetch(this.root+'cart/add.js',{
          method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:[{id,quantity:1}],sections,sections_url:location.pathname})
        });
        const result=await response.json();
        if(!response.ok){this.notify(typeof result.description==='string'?result.description:this.messages.error);return;}
        confirmed=true;this.notify(this.messages.added);
        await this.refreshCount();
        await this.openDrawer(result,button);
      } catch (_) {this.notify(confirmed?this.messages.drawer:this.messages.confirm,true);}
      finally{this.busy=false;form.removeAttribute('aria-busy');buttons.forEach((node,index)=>node.disabled=states[index]);}
    }
  }
  customElements.define('qsf-sextou-campaign',SextouCampaign);
})();


  } catch(e) { console.error(e); }
})();
})();
